import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from 'body-scroll-lock';
import { slideToggle } from './Slide';

const Nav = () => {
  const nav = document.querySelector('.main-nav');
  const menuToggle = document.querySelector('[data-menu-toggle]');

  if (menuToggle) {
    menuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      menuToggle.classList.toggle('is-open');
      nav.classList.toggle('is-open');

      if (nav.classList.contains('is-open')) {
        disableBodyScroll(nav);
      } else {
        enableBodyScroll(nav);
      }
    });
  }

  nav.addEventListener('click', (e) => {
    if (e.target && e.target.matches('li.menu-item svg')) {
      const subNav = e.target.parentNode.querySelector('.sub-menu');
      e.target.parentNode.classList.toggle('is-open');
      slideToggle(subNav, 200);
    }
  });
};

export default Nav;
